import KsAjax from './KsAjax';
import MessageAlert from '../common/message';
import * as _ from 'lodash';

export default function (apis:any) {
    function failCallback(c:any, e:any) {
        // let unknownMsg = '未知错误! code: ' + c;
        let unknownMsg = 'ERROR! code: ' + c;
        try {
            let msg = _.get(e, 'Error.Message');
            if (!msg) {
                // msg = _.get(e, 'error.message');
                msg = _.get(e, 'error.message') || unknownMsg;
            }
            // let code = _.get(e, 'Error.Code');
            // if (code == 'ServiceTimeout') {
            //     msg = ''
            // }
            MessageAlert.send(msg, "error");
        } catch (er) {
            // MessageAlert.send('未知错误! code: ' + c, "error");
            MessageAlert.send(unknownMsg, 'error');
        }
    }
    var request:any = {};
    var noAlertRequest:any = {};
    _.forEach(apis, (url, name) => {
        var method = 'get';
        if (typeof url === 'object') {
            method = url.method;
            url = url.url;
        }

        request[name] = function (...args:any) {
            return KsAjax[method](url, ...args).fail(failCallback);
        };
        noAlertRequest[name] = function (...args:any) {
            return KsAjax[method](url, ...args);
        };
    });
    return {
        noAlertRequest,
        request
    };
};
